import { ProductState } from "../Model/ProductState";
import { ProductRepository } from "../Repository/ProductRepository";



export interface UpdateStateProductUseCase {
    invoke: (data: ProductState) => Promise<boolean>;
  }
  
  export class UpdateStateProduct implements UpdateStateProductUseCase {
    private productRepo: ProductRepository;
    constructor(_ProductRepo: ProductRepository) {
      this.productRepo = _ProductRepo;
    }
  
    async invoke(data: ProductState){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.productRepo.updateStateProduct(data);
        return update;
    }
  }